module.exports = __webpack_public_path__ + "static/expansion-valve-8ec6d3fc5330b657e760f77a0cd31c67.png";